<template>
  <div class="other detail-item" v-if="editingData">

    <div class="head"><b>その他</b></div>
    <p
      v-if="editingData.koyou_type === OptionConst.KOYOU_TYPE.GEKKYUU || editingData.koyou_type === OptionConst.KOYOU_TYPE.GEKKYUU_MUKI || editingData.koyou_type === OptionConst.KOYOU_TYPE.JIKYUU">
      {{ Message.OTHER }}</p>
    <p class="pre"
      v-else-if="editingData.syozoku_id === OptionConst.SYOZOKU.PM && (editingData.koyou_type === OptionConst.KOYOU_TYPE.PART || editingData.koyou_type === OptionConst.KOYOU_TYPE.PART_MUKI)" >
      {{ Message.OTHER_COUNTER_PM }}</p>
    <p class="pre"
    v-else-if="editingData.syozoku_id === OptionConst.SYOZOKU.PG && (editingData.koyou_type === OptionConst.KOYOU_TYPE.PART || editingData.koyou_type === OptionConst.KOYOU_TYPE.PART_MUKI)" >
      {{ Message.OTHER_COUNTER_PG }}</p>
  
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { KoyouKeiyakuDetail } from '@/types/KoyouKeiyakuDetail';
import Message from "@/const/KoyouKeiyaku/Message";
import OptionConst from '@/const/Option';

export default defineComponent({
  props: {
    editingData: {
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: null
    }
  },
  setup() {
    return {
      Message,
      OptionConst
    }
  }
})
</script>

<style lang="scss" scoped>
@import '@scss/components/koyoukeiyaku.scss';
@import '@scss/components/koyoukeiyaku-detail.scss';

</style>
